import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import $ from "jquery";
import languageES from "datatables.net-plugins/i18n/es-MX.js";
import api from "@/api/api.js";
import Swal from "sweetalert2";
import { startImpersonation } from "@/store/authSlice.js";

const ImpersonateUser = () => {
  const tableRef = useRef(null);
  const dataTable = useRef(null);
  const dispatch = useDispatch();

  const handleImpersonate = (userId, name) => {
    Swal.fire({
      title: "¿Suplantar a este usuario?",
      text: `Verás la aplicación como ${name}. Podrás regresar a tu sesión desde la barra superior.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, suplantar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      api
        .post(`/users/${userId}/impersonate`, {})
        .then(({ data }) => {
          dispatch(startImpersonation(data));
          window.location.href = "/dashboard";
        })
        .catch((error) => {
          const message =
            error.response?.data?.error ||
            error.response?.data?.["hydra:description"] ||
            "No se pudo suplantar al usuario.";
          Swal.fire("Error", message, "error");
        });
    });
  };

  useEffect(() => {
    dataTable.current = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      language: languageES,
      ajax: async (dataTablesParams, callback) => {
        try {
          const response = await api.get("/users", {
            params: {
              page: dataTablesParams.start / dataTablesParams.length + 1,
              itemsPerPage: dataTablesParams.length,
              search: dataTablesParams.search.value,
            },
          });

          callback({
            data: response.data["hydra:member"],
            recordsTotal: response.data["hydra:totalItems"],
            recordsFiltered: response.data["hydra:totalItems"],
          });
        } catch (error) {
          console.error("Error al cargar datos:", error);
          callback({ data: [] });
        }
      },
      columns: [
        {
          title: "Nombre",
          render: (data, type, row) =>
            `${row.userProfile?.name ?? ""} ${row.userProfile?.lastname ?? ""}`,
        },
        {
          title: "Tipo",
          render: (data, type, row) => row.userProfile?.userType ?? "",
        },
        { title: "Email", data: "username" },
        {
          title: "Acciones",
          render: (data, type, row) =>
            `<button class="btn btn-warning btn-impersonate" data-id="${row.id}" data-name="${row.username}">
               <i class="bi bi-person-check me-1"></i>Suplantar
             </button>`,
        },
      ],
    });

    $(tableRef.current).on("click", ".btn-impersonate", function () {
      handleImpersonate($(this).data("id"), $(this).data("name"));
    });

    return () => {
      const table = $(tableRef.current);
      table.off("click", ".btn-impersonate");
      if (dataTable.current) {
        dataTable.current.destroy();
      }
    };
  }, []);

  return (
    <div className="col">
      <div className="card">
        <div className="card-body p-1">
          <div className="card-title p-1">
            <h5 className="card-title p-1">Suplantar usuario</h5>
            <p className="text-muted px-1 mb-0">
              Selecciona un usuario para ver la aplicación como él. No es posible
              suplantar a otro jefe de contadores.
            </p>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="display"
              style={{ width: "100%" }}
            ></table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpersonateUser;
